import { createSlice } from "@reduxjs/toolkit";
const initialAuthState = {
  modalValue: {
    branch: "",
    UMRNNumber: "",
    applicationNum: "",
    customerId: "",
    customerName: "",
    mandateNumber: "",
    mandateBank: "",
    status: "",
    initialStatus: "",
    editLock: "",
  },
  editLock: {
    editLockFlag: "",
    branch: "",
    applicationNumber: "",
  },
};
const VerificationModalReducer = createSlice({
  name: "verificationModal",
  initialState: initialAuthState,
  reducers: {
    updatemodalValues(state, action) {
      state.modalValue.branch = action.payload.branch;
      state.modalValue.UMRNNumber = action.payload.umrnNumber;
      state.modalValue.applicationNum = action.payload.applicationNum;
      state.modalValue.customerId = action.payload.customerId;
      state.modalValue.customerName = action.payload.applicationCustomer;
      state.modalValue.mandateNumber = action.payload.mandateNum;
      state.modalValue.mandateBank = action.payload.nachBankVoList[0].bankName;
      state.modalValue.initialStatus = action.payload.status;
      state.modalValue.editLock = action.payload.editLock;
    },
    resetValues(state, action) {
      state.modalValue.UMRNNumber = "";
      state.modalValue.applicationNum = "";
      state.modalValue.customerId = "";
      state.modalValue.customerName = "";
      state.modalValue.mandateNumber = "";
      state.modalValue.mandateBank = "";
      state.modalValue.status = "";
      state.modalValue.initialStatus = "";
    },
    updateStatus(state, action) {
      state.modalValue.status = action.payload;
    },
    updateUMRNNumber(state, action) {
      state.modalValue.UMRNNumber = action.payload;
    },
    updateEditLockFlag(state, action) {
      state.editLock.editLockFlag = action.payload;
    },
    updateEditLockBranch(state, action) {
      state.editLock.branch = action.payload;
    },
    updateEditLockApplicationNumber(state, action) {
      state.editLock.applicationNumber = action.payload;
    },
  },
});
export const VerificationModalReducerAction = VerificationModalReducer.actions;
export default VerificationModalReducer.reducer;
